export const getCapitalizeWord = (str: string) => {
  const uppercaseString = str.toUpperCase();
  return uppercaseString.charAt(0) + uppercaseString.slice(1).toLowerCase();
};
